import ActionUtility from "../../utilities/ActionUtility";
import PlatformEffect from "./PlatformEffect";
import PlatformModel from "./models/PlatformModel";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";

export default class PlatformAction {
  //PLATFORM requests
  static REQUEST_PLATFORM = "PlatformAction.REQUEST_PLATFORM";
  static REQUEST_PLATFORM_FINISHED = "PlatformAction.REQUEST_PLATFORM_FINISHED";

  //PLATFORM list (for Filter drop down)
  static REQUEST_PLATFORM_FILTER = "PlatformAction.REQUEST_PLATFORM_FILTER";
  static REQUEST_PLATFORM_FILTER_FINISHED =
    "PlatformAction.REQUEST_PLATFORM_FILTER_FINISHED";

  //METHODS

  //PLATFORM get method
  static requestPlatform(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        PlatformAction.REQUEST_PLATFORM,
        PlatformEffect.requestPlatform,
        params
      );
    };
  }

  // PLATFORM list get  method for filter dropdown
  static requestFilterPlatform(params) {
    return async (dispatch, getState) => {
      if (localStorage.getItem("platform") !== null) {
        let data = localStorage.getItem("platform");
        const model = new PlatformModel(JSON.parse(data));
        const isError = model instanceof HttpErrorResponseModel;
        dispatch(
          ActionUtility.createAction(
            `${PlatformAction.REQUEST_PLATFORM_FILTER}_FINISHED`,
            model,
            isError
          )
        );

        return model;
      } else {
        await ActionUtility.createThunkEffect(
          dispatch,
          PlatformAction.REQUEST_PLATFORM_FILTER,
          PlatformEffect.filterRequestPlatform,
          params
        );
      }
    };
  }
}
